module.exports = __webpack_public_path__ + "img/service-02.9ba692e3.webp";